export const DONE_ICON_TEST_ID = 'done_icon';
export const COPY_ICON_TEST_ID = 'copy_icon';
